import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { storesInitialState } from './state';
import { IStoreGroup, IStoreItem, IStoreLogged, IStoreSelected, IStoresList } from './types';

export const storesSlice = createSlice({
  name: 'store',
  initialState: storesInitialState,
  reducers: {
    setStoreSelected: (state, action: PayloadAction<IStoreSelected>) => {
      state.storeSelected = action.payload;
      return state;
    },
    clearStoreSelected: (state) => {
      state.storeSelected = storesInitialState.storeSelected;
      return state;
    },
    setStoreLogged: (state, action: PayloadAction<IStoreLogged>) => {
      state.storeLogged = action.payload;
      return state;
    },

    setStoreList: (state, action: PayloadAction<IStoreItem[]>) => {
      state.storeList = action.payload;
      return state;
    },
    setAllStoreList: (state, action: PayloadAction<IStoresList>) => {
      state.stores = action.payload;
      return state;
    },
    setFilterSearchStore: (state, action: PayloadAction<string>) => {
      state.storesFilter.searchStore = action.payload;
      return state;
    },
    setFilterCurrentPage: (state, action: PayloadAction<number>) => {
      state.storesFilter.page = action.payload;
      return state;
    },
    setFilterRowsPerPage: (state, action: PayloadAction<number>) => {
      state.storesFilter.rowsPerPage = action.payload;
      return state;
    },
    clearFilters: (state) => {
      state.storesFilter = storesInitialState.storesFilter;
      return state;
    },

    setStoreGroupList: (state, action: PayloadAction<IStoreGroup[]>) => {
      state.storeGroup.storeGroupList = action.payload;
      return state;
    },

    setStoreGroupSelected: (state, action: PayloadAction<Partial<IStoreGroup>>) => {
      state.storeGroup.storeGroupSelected = action.payload;
      return state;
    },
  },
});
